/**
 * Mirrors backend ADDON_LIMITS from backend/app/models/addon.py.
 * Used for display purposes only — enforcement happens server-side.
 */
export const ADDON_LIMITS: Record<string, Record<string, number>> = {
  tabletop_creator: { max_scenarios: 2 },
};
